import { fetchAndProcessErrors } from '../../utils/fetchwrapper.js';
import { processBody } from '../../utils/fetchwrapperUtils/responseProcessors.js';
import { trustProfileSettingsSchema } from '../../models/trust/morph.js';
import { trustProfileSettings } from '../../models/trust/zod.js';

const getProfileTrustSettings = (origin, userID, trustAuthJWT) => fetchAndProcessErrors({ url: `${origin}/profile/sdrn:subito:user:${userID}/settings` }, {
    headers: { Authorization: `Bearer ${trustAuthJWT}` },
}).then(processBody(trustProfileSettingsSchema, trustProfileSettings));

export { getProfileTrustSettings };
//# sourceMappingURL=client.js.map
